import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';

export namespace NCmsPaymentMethodsLogos {
    export const ID = 'payments-methods-logos-block';

    export interface IBlockData extends Catalog.IBlockData<IBlockContent> {}

    export interface IBlockContent {
        paymentMethods: string[];
    }
}

@ICmsComponent<PaymentMethodsLogosBlockComponent>({
    id: NCmsPaymentMethodsLogos.ID,
    block: {
        url: NCmsPaymentMethodsLogos.ID
    },
    name: 'Payment methods logos',
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'paymentMethods',
            type: NICmsContentField.EFieldType.choice,
            title: 'Payment methods logos',
            required: true,
            multiple: true,
            options: [
                { key: 'visa', title: 'Visa' },
                { key: 'mastercard', title: 'Mastercard' },
                { key: 'maestro', title: 'Maestro' },
                { key: 'apple', title: 'Apple' },
                { key: 'amex', title: 'Amex' },
                { key: 'google', title: 'Google' },
                { key: 'klarna', title: 'Klarna' },
                { key: 'paypal', title: 'Paypal' }
            ]
        }
    ]
})
@Component({
    selector: 'payments-methods-logos-block',
    templateUrl: './payments-methods-logos-block.html',
    standalone: true,
    imports: [TranslationModule, NgClass],
    styles: [
        `
            :host {
                display: flex;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentMethodsLogosBlockComponent extends UiComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsPaymentMethodsLogos.IBlockContent;
}
